import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {HELP_CHAT_CHANNEL_ID, LinkToArticle} from "../help_center/LinkToArticle";
import {withTranslation} from 'react-i18next';
import {FaIcon} from "../FaIcon";

class ClientIntegrationsInfoClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            savingChanges: false,
            exportSheetUrlMetrics: null,
            exportSheetUrlIndicators: null,
            externalChatChannelId: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleExportSheetUrlMetrics = this.handleExportSheetUrlMetrics.bind(this);
        this.handleExportSheetUrlIndicators = this.handleExportSheetUrlIndicators.bind(this);
        this.handleExternalChatChannelId = this.handleExternalChatChannelId.bind(this);
    }

    getClientIntegrationsData() {
        this.setState({loading: true});
        new APIClient(this.updateClientIntegrationsDataURL()).call('GET').then((data) => {
            this.setState({loading: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    exportSheetUrlMetrics: data.data["export_sheet_url_for_metrics"],
                    exportSheetUrlIndicators: data.data["export_sheet_url_for_indicators"],
                    externalChatChannelId: data.data["external_chat_channel_id"]
                });
            }
        })
    }

    componentDidMount() {
        this.getClientIntegrationsData();
    }

    updateClientIntegrationsDataURL() {
        return API_URL + 'client/' + this.props.clientId + '/integrations-data';
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        const dataToPost = {
            'export_sheet_url_for_metrics': this.state.exportSheetUrlMetrics,
            'export_sheet_url_for_indicators': this.state.exportSheetUrlIndicators,
            'external_chat_channel_id': this.state.externalChatChannelId
        };

        new APIClient(this.updateClientIntegrationsDataURL()).call('PUT', dataToPost).then((data) => {
            this.setState({savingChanges: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                alert(this.props.t('client_settings.save_success'));
            }
        });
    }

    handleExportSheetUrlMetrics(event) {
        this.setState({
            exportSheetUrlMetrics: event.target.value
        });
    }

    handleExportSheetUrlIndicators(event) {
        this.setState({
            exportSheetUrlIndicators: event.target.value
        });
    }

    handleExternalChatChannelId(event) {
        this.setState({
            externalChatChannelId: event.target.value
        });
    }

    renderSaveButton() {
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={this.props.t('client_settings.save')}/>;
        }
    }

    renderClientIntegrationsInfo() {
        const {t} = this.props;
        const isSettingsCard = this.props.settingsCard === true;

        if (this.state.loading === false) {
            return (
                <div className={`box${isSettingsCard ? ' client-settings-card client-settings-integrations-card' : ''}`}>
                    <header className={isSettingsCard ? 'client-settings-card-header' : 'box-header'}>
                        {isSettingsCard && (
                            <span className="client-settings-card-icon">
                                <FaIcon iconName="plug"/>
                            </span>
                        )}
                        <span>
                            <h2 className="box-title">{t('client_settings.integrations_title')}</h2>
                            {isSettingsCard && <p>{t('client_settings.integrations_description')}</p>}
                        </span>
                    </header>
                    <div className={isSettingsCard ? 'client-settings-card-body' : ''}>
                        <div className="form-header" style={{marginBottom: '1.5em'}}>
                            <h3 className="form-title"><span>{t('client_settings.webhook_title')}</span></h3>
                        </div>
                        <div className="form-row">
                            <label>{t('client_settings.chat_channel_label')}:<LinkToArticle article={HELP_CHAT_CHANNEL_ID}/></label>
                            <input onChange={this.handleExternalChatChannelId}
                                   name="chat_channel_id" type="text"
                                   value={this.state.externalChatChannelId}/>
                            <p className="field-footnote pb-0 mb-0">{t('client_settings.chat_channel_footnote')}</p>
                        </div>
                    </div>
                    {/*<div className="form-header" style={{marginBottom: '1.5em', marginTop: '2em'}}>*/}
                    {/*    <h3 className="form-title"><span>Exportación a Google Sheet</span></h3>*/}
                    {/*</div>*/}
                    {/*<div className="form-row">*/}
                    {/*    <label>Google Sheet url para exportar métricas de campañas de presupuestos:</label>*/}
                    {/*    <input onChange={this.handleExportSheetUrlMetrics} name="export_sheet_url_metrics" type="text"*/}
                    {/*           value={this.state.exportSheetUrlMetrics}*/}
                    {/*           readOnly={true}*/}
                    {/*           placeholder={"Estamos trabajando en esta funcionalidad."}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/*<div className="form-row">*/}
                    {/*    <label>Google Sheet url para exportar indicadores de presupuestos:</label>*/}
                    {/*    <input onChange={this.handleExportSheetUrlIndicators} name="export_sheet_url_indicators"*/}
                    {/*           type="text"*/}
                    {/*           value={this.state.exportSheetUrlIndicators}*/}
                    {/*           readOnly={true}*/}
                    {/*           placeholder={"Estamos trabajando en esta funcionalidad."}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className={isSettingsCard ? 'client-settings-card-footer' : 'submit-row'}>
                        {this.renderSaveButton()}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -wide">
                {this.renderClientIntegrationsInfo()}
            </form>
        )
    }
}

export const ClientIntegrationsInfo = withTranslation()(ClientIntegrationsInfoClass);
